import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import { genericFetch }  from './common-service'

const SCENARIOS = 'scenarios'
const VALIDATED = 'validated'
const LA = 'localautority'

export function getAllScenarios(id) {
	const url = `${apiBaseUrl}/${SCENARIOS}/la/${id}/${VALIDATED}/all`
	const init = {
		headers: getBaseHeader(true),
	}

	return genericFetch(url, init)
}

export function getSelectedScenarios(laId,sid,ppiId,year) {
	const url = `${apiBaseUrl}/${SCENARIOS}/calculate/localAuthority/${laId}/scenario/${sid}?year=${year}`
	const init = {
		headers: getBaseHeader(true),
	}

	return genericFetch(url, init)
}

export function getRecalculeScenarios(laId,recette,depense,id,year) {
	const url = `${apiBaseUrl}/${SCENARIOS}/calculate/caf-brute/localAuthority/${laId}/scenario/${id}/recette/${recette}/depense/${depense}?year=${year}`
	const init = {
		headers: getBaseHeader(true),
	}

	return genericFetch(url, init)
}

export function saveSelectedScenarios(data,id) {
	const url = `${apiBaseUrl}/${SCENARIOS}/${id}/arbitrage`
	const init: RequestInit = {
		body: JSON.stringify(data),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}
	return genericFetch(url, init)
}








// WEBPACK FOOTER //
// ./src/service/sfp/politique-services.ts